<rt-smart-report [gridId]="gridId" [apiCall]="apiCall" [pageHeader]="pageHeader"> </rt-smart-report>
